import { type BaseConfigItem, type TabQuery } from './TabsMenu.types';
import { type ValueType } from '../core/Tabs.types';

type QueryInput<T extends ValueType> = {
  index?: number | null;
  value?: T | null;
};

const createTabQuery = <T extends ValueType>(input: QueryInput<T>): TabQuery<T> | null => {
  const { index, value } = input;

  if (index != null) return { index };
  if (value != null) return { value };

  return null;
};

const getTabConfig = <T extends BaseConfigItem>(
  tabConfigs: readonly T[],
  position: ((tab: T) => boolean) | number,
) => {
  const index = typeof position === 'number' ? position : tabConfigs.findIndex(position);

  if (index === -1) return null;

  const config = tabConfigs[index];

  if (!config) return null;

  return {
    config,
    index,
  };
};

const getTabsBounds = (tabs: readonly BaseConfigItem[]) => ({
  max: Math.max(0, tabs.length - 1),
  min: 0,
});

const getVisibleTabs = <T extends BaseConfigItem>(tabs?: readonly T[]) =>
  tabs?.filter((tab) => tab.visible !== false) ?? [];

export { createTabQuery, getTabConfig, getTabsBounds, getVisibleTabs };
